<template>
    <HeaderNavFirst />
    <main>
        <AboutSection />
    </main>
    <FooterNav />
</template>

<script>
import { defineComponent } from 'vue';
import {
    HeaderNavFirst,
    FooterNav,
} from '../default/components';
import {
    AboutSection,
} from '@/modules/about/features/components';

export default defineComponent({
    components: {
        HeaderNavFirst,
        FooterNav,
        AboutSection,
    },
});
</script>
